<template>
  <div class="main_floor" :class="{open: item.apartments_open}">
    <div class="head">
        <div class="fields_container">
            <li>
                <label>מספר הקומה</label>
                <input type="number" min="0" v-model="item.floor_num">
            </li>
            <li>
                <label>מספר יחידות דיור בקומה</label>
                <input type="number" min="0" v-model="item.apartments_num">
            </li>
        </div>
        <div class="btns_container">
            <div class="btn_b text_s" @click="saveFloor()">המשך</div>
        </div>
    </div>
    <div class="content">
        <div class="apartments_container" v-if="item.apartments_open" >
            <template v-for="(apartment, key) in item.apartments" :key="key">
                <Apartment :index="key" :apartmentComp="apartment" @update="apartment = $event" />
            </template>
        </div>
    </div>
             
  </div>
</template>

<script>
import Apartment from './Apartment.vue'

export default {
    props:{
        floorComp:{
            type: Object,
            required: true
        }
    },
    components: { Apartment },
     beforeMount(){
        this.item = this.floorComp;
    },
    data() {
        return {
            item: this.floorComp,
         
        }
    },
    methods: {
          saveFloor(){
            if(this.item.apartments_num > 0 && this.item.apartments.length == 0)
            {
                for (let i = 0; i < this.item.apartments_num; i++)
                {
                    this.addApartment();
                }
            }
            else if(this.item.apartments_num > 0 && this.item.apartments.length > 0)
            {
                if(this.item.apartments_num > this.item.apartments.length)
                {
                for (let i = this.item.apartments.length; i < this.item.apartments_num; i++)
                {
                    this.addApartment();
                }
                }
                else if(this.item.apartments_num < this.item.apartments.length)
                {
                this.item.apartments = this.item.apartments.slice(0, this.item.apartments_num);
                }
            }
            
            setTimeout(() => {
                this.item.apartments_open = true;
            }, 100);
        },
        addApartment(){
            let Appartment = {
                num_units: 0,
                num_parking: 0,
                special_note: '',
                num_storage: 0,
                air_directions: [],
                type_ownership: null,
                more_fields: [],
                // is_garden: false,
                // is_roof: false,
            };
            this.item.apartments.push(Appartment);
        },
        add_apartment() {
            this.apartments.push({rooms_num: 0, parking: 0, storage: 0, air_directions: [], type_ownership: '', special_comments: '', special_note: '' })
        }
    },
    watch: {
        item: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    },

}
</script>

<style lang="scss">
.main_floor { display: flex; flex-direction: column; gap: var(--gap_xmid); border-radius: var(--radius); background: #fff; border: 1px solid var(--pageBG); padding: 16px 32px 24px 32px;
    &.open { background: #f5f9fa; }
    .head { display: flex; justify-content: space-between; align-items: flex-end;
        .fields_container { display: flex; gap: 32px;}
    }
    .content {
        .apartments_container {display: flex; flex-direction: column; gap: var(--gap);
            .apartment_container { background: #fff; display: flex; flex-direction: column; gap: var(--gap_mid); border: 1px solid var(--pageBG); border-radius: 8px; box-shadow: var(--box-shadow); padding: 24px 32px;
                .fields_container { display: flex; gap: var(--gap_mid);    align-items: flex-end;
                    li {flex: 1;}
                    .select_container {flex: 2;}
                }
            }
        }
    }
}
</style>